
import img2 from "../assets/home/medium-shot-woman-working-laptop.jpg";
import img3 from "../assets/home/shaking-hand-speaker.jpg";
import hiring from "../assets/icons/hiring.jpg";

const Homedata = [
  {
    icon: hiring,
  },
  {
    icon: img2,
  },
  {
    icon: img3,
  },
];

export default Homedata;
